/**
 * Precio mostrado al usuario desde GET /suscripcions (precioRedondeado).
 */
const subscriptionDisplayPrice = info => {
  if (!info || typeof info !== "object") return null
  const value = info.precioRedondeado
  if (value == null || value === "") return null
  const n = Number(value)
  return Number.isNaN(n) ? null : n
}

const subscriptionBasePrice = subscriptionDisplayPrice

export { subscriptionDisplayPrice, subscriptionBasePrice }
